// TravelDestinations.js
import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Briefcase, Mail } from 'lucide-react';

const TravelDestinations = () => {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack">
            Destinations & categories we commonly support
          </h2>
        </motion.div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Destinations */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <div className="flex items-start mb-4">
              <div className="w-12 h-12 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                <Globe className="w-6 h-6 text-white" />
              </div>
            </div>
            <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
              Destinations
            </h3>
            <p className="text-gray-600 leading-relaxed">
              UK, Schengen Area, Canada, US, UAE, South Africa (others on request).
            </p>
          </motion.div>

          {/* Categories */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="flex items-start mb-4">
              <div className="w-12 h-12 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                <Briefcase className="w-6 h-6 text-white" />
              </div>
            </div>
            <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
              Categories
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Visit/Tourist, Business, Study, Work, Family/Dependent, Short-term training, Conferences.
            </p>
          </motion.div>

          {/* Note */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="flex items-start mb-4">
              <div className="w-12 h-12 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                <Mail className="w-6 h-6 text-white" />
              </div>
            </div>
            <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
              Custom Routes
            </h3>
            <p className="text-gray-600 leading-relaxed">
              If your route isn't listed, ask via Contact—we'll confirm feasibility.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TravelDestinations;
